// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"1ffd2ad8","156":"88d905c0","782":"93ae27c2","787":"68b05114"}[chunkId] + ".chunk.js";
};